module.exports = __webpack_public_path__ + "static/img/Bottle Opener 2-1.e69e825.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bottle Opener 2-1.jpg
// module id = Y1wC
// module chunks = 1